import { render } from "./AdminPrivacypolicy.vue?vue&type=template&id=5c27d4b2&lang=true"
import script from "./AdminPrivacypolicy.vue?vue&type=script&lang=js"
export * from "./AdminPrivacypolicy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__